module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v2-400.99ac41de.png";